<template>
  <div> 
    <DataTable
      :key="dataTableKey"
      :value="data"
      :paginator="true"
      dataKey="id"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="10"
      :rowHover="true"
      :selection.sync="selectedData"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} Customer Histories"
      :scrollable="true"
      scrollHeight="400px"
      :style="{ 'width': '100%' }"
    >
      <template #empty> No {{ name }} found. </template>
      <template #loading> Loading {{ name }} data. Please wait. </template>
      <Column selectionMode="multiple" headerStyle="width: 3em;"></Column>
      <Column
        field="dateCreated"
        header="Date"
        headerStyle="width: 6em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.dateCreated }}
          </div>
        </template>
      </Column>
      <Column
        field="user"
        header="User"
        headerStyle="width: 10em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.user && slotProps.data.user.fullName ? slotProps.data.user.fullName : '' }}
          </div>
        </template>
      </Column>
      <Column
        field="histType"
        header="Type"
        headerStyle="width: 6em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.histType }}
          </div>
        </template>
      </Column>
      <Column
        field="histDesc"
        header="Description"
        headerStyle="width: 15em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div class="under_lined" @click="goTo(slotProps.data)">
            {{ slotProps.data.histDesc }}
          </div>
        </template>
      </Column>
      <Column
        field="eventStatus"
        header="Status"
        headerStyle="width: 5em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.eventStatus }}
          </div>
        </template>
      </Column>
    </DataTable>
           
    <component
      :key="activityFormKey"
      :is="activityForm"
      :activityForm="activityDialog"
      mode="auto"
      :activityToEdit="activity"
      :disabledArr="disabledArr"
      @close="activityDialog = false"
    />

    <component
      :is="noteForm"
      :reload="reloadNoteForm"
      :noteDialog="noteDialog"
      :noteToEdit="note"
      :disabledArray="disabledArr"
      :customer1="customer"
      @close="noteDialog = false"
    />
    
    <!-- Enquiry form -->
      <!-- :key="enquiryFormKey" -->
    <component
      :is="enquiryForm"
      v-if="enquiryDialog"
      :opportunityDialog="enquiryDialog"
      :opportunityToEdit='enquiry'
      :disabledArray="disabledArr"
      @close="enquiryDialog = false"
    />

  </div>
</template>

<script>
import ActivityService from "@/service/ActivityService";
import CustomerService from "@/service/CustomerService";
import OpportunityService from "@/service/OpportunityService";

import ActivityForm from "@/mbp/universalComponents/activity/ActivityForm.vue";
import NoteForm from '@/mbp/universalComponents/note/NoteForm'
import OpportunityForm from '@/mbp/universalComponents/opportunity/OpportunityForm'

export default {
  components: {
    ActivityForm,
    NoteForm,
    OpportunityForm
  },
  props: [
    'data',
    'name',
    'loading',
    'globalFilter',
    'customer'
  ],
  data: () => ({
    activityService: new ActivityService(),
    customerService: new CustomerService(),
    opportunityService: new OpportunityService(),
    selectedData: null,
    dataTableKey: 0,
    filters: {
      global: ''
    },
    activityDialog: false,
    disabledArr: [],
    activity: {},
    activityFormKey1: 0,
    noteDialog: false,
    note: {},
    reloadNoteForm: 0,
    unRequestedActivity: true,
    unRequestedNote: true,
    enquiry: {},
    enquiryFormKey1: 0,
    enquiryDialog: false,
    unRequestedEnquiry: true
  }),
  computed: {
    activityFormKey: {
      set() {
        this.activityFormKey1++
      },
      get() {
        return 'activityFormKey-' + this.activityFormKey1.toString()
      }
    },
    enquiryFormKey: {
      set(val) {
        
        this.enquiryFormKey1++
      },
      get() {
        return 'enquiryFormKey' + this.enquiryFormKey1.toString()
      }
    },
    activityForm() {
      return (this.unRequestedActivity === false || this.activityDialog) ? ActivityForm : null
    },
    noteForm() {
      return (this.unRequestedNote === false || this.noteDialog) ? NoteForm : null
    },
    enquiryForm() {
      return (this.unRequestedEnquiry === false || this.enquiryDialog) ? OpportunityForm : null
    }
  },
  watch: {
    data(val) {
      
      this.dataTableKey++
    },
    globalFilter(val) {
      this.filter.global = val
      this.dataTableKey++
    }
  },
  created() {
    this.filters.global = this.$route.query.search
  },
  methods: {
    goTo(data) {
      
      this.note = {}
      this.enquiry = {}

      if (data) {
        if (data.linkTo === "ACTIVITY") {
          this.activityService
            .getActivity(data.linkId)
            .then(data => {
              this.activity = data
              this.disabledArr = [
                'buttons',
                'reminderDate',
                'reminderTime',
                'reminder',
                'reminderType',
                'duration',
                'endDate',
                'endTime',
                'startDate',
                'startTime',
                'notes',
                'quotation',
                'customer',
                'contact',
                'activityType',
                'mbpBranch',
                'user',
                'dateCreated',
                'subject',
              ]
              this.unRequestedActivity = false
              this.activityDialog = true
              this.activityFormKey++

            })
            .catch((e) => {
              
                
              this.$store.dispatch('addErrorMessage', {
                severity: 'error',
                content: 'Some data was not loaded from "activity/{id}"'
              })
            });

        } else if (data.linkTo === "NOTE") {
          this.customerService
            .getNote(data.linkId)
            .then(data => {
              this.note = data
              this.disabledArr = [
                'noteHeader',
                'noteTags',
                'Customer',
                'Contact',
                'enquiry',
                'user',
                'noteDetails',
                'buttons',
              ]
              this.unRequestedNote = false
              this.noteDialog = true
              this.reloadNoteForm
            })
            .catch((e) => {
              
                
              this.$store.dispatch('addErrorMessage', {
                severity: 'error',
                content: 'Some data was not loaded from "customernote/{id}"'
              })
            });
          
        } else if (data.linkTo === "ENQUIRY") {
          this.opportunityService
            .getOpportunity(data.linkId)
            .then(data => {
              this.enquiry = data
              this.disabledArr = [
                'Description',
                'Address 1',
                'Address 2',
                'Address 3',
                'City/Town',
                'Post Code',
                'Customer',
                'Contact',
                'Project Type',
                'mbpBranch',
                'Phone No',
                'Email',
                'Sales Exec',
                'Requested By',
                'ABI No',
                'Customer Ref',
                'Notes',
                'Buttons'
              ]
              this.unRequestedEnquiry = false
              this.enquiryDialog = true
              this.enquiryFormKey = this.enquiryFormKey1 + 1
            })
            .catch((e) => {
              
                
              this.$store.dispatch('addErrorMessage', {
                severity: 'error',
                content: 'Some data was not loaded from "opportunity/{id}"'
              })
            });

        }
      }
    }
  }
}
</script>

<style>

</style>